import React, { Component } from 'react';
import yaml from 'js-yaml';
import Fade from 'react-reveal/Fade';

import { buildPath } from '../utils/route_utils.js'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'
import Footer from '../components/Footer'

import '../css/BlogPage.css';

class BlogPage extends Component {

  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this)
    this.update_lang = this.update_lang.bind(this)
    this.revealHashPost = this.revealHashPost.bind(this)
    this.state = {
      lang: this.props.lang,
      posts: [],
      activeCategory: 'all',
      expandedId: null,
      heroTitle: {
        zh: "部落格 & 最新消息",
        en: "Blog & News",
        ja: "ブログ & ニュース"
      },
      categoryLabels: {
        all: { zh: "全部", en: "All", ja: "すべて" },
        "Company News": { zh: "公司消息", en: "Company News", ja: "企業ニュース" },
        "Technology": { zh: "科技小文", en: "Technology", ja: "テクノロジー" }
      }
    };
  }

  componentDidMount() {
    updateSEO('blog', this.state.lang, '/blog');
    window.addEventListener('hashchange', this.revealHashPost);
    fetch(process.env.PUBLIC_URL + '/yaml/blog_posts.yaml')
      .then(response => response.text())
      .then(text => {
        const parsed = yaml.load(text);
        if (parsed && parsed.posts) {
          // Honour /blog#<post id> deep links once the cards exist.
          this.setState({ posts: parsed.posts }, this.revealHashPost);
        }
      });
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.revealHashPost);
  }

  /**
   * The home-page news section links to '/blog#<post id>' for posts that
   * have no route of their own. If the hash names a known post, expand it
   * in place (posts with their own article route just scroll into view)
   * and bring its card to the top of the viewport.
   */
  revealHashPost() {
    const raw = window.location.hash || '';
    if (raw.length < 2) return;
    let id = raw.slice(1);
    try { id = decodeURIComponent(id); } catch (e) { /* keep raw */ }
    const post = this.state.posts.find(p => p && p.id === id);
    if (!post) return;

    const scrollToCard = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ block: 'start' });
    };

    if (post.link) {
      scrollToCard();
      return;
    }
    // 'all' guarantees the card is rendered whatever filter was active.
    this.setState({ expandedId: id, activeCategory: 'all' }, () => {
      window.requestAnimationFrame(scrollToCard);
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  render() {
    const lang = this.state.lang;
    const filtered = this.state.activeCategory === 'all'
      ? this.state.posts
      : this.state.posts.filter(p => p.category.en === this.state.activeCategory);
    const categories = ['all', 'Company News', 'Technology'];
    const readMoreLabel = { zh: "閱讀更多", en: "Read More", ja: "続きを読む" };
    const collapseLabel = { zh: "收起", en: "Collapse", ja: "閉じる" };
    const readArticleLabel = { zh: "閱讀全文", en: "Read Article", ja: "記事を読む" };

    return (
      <div className={"blog_page " + lang}>
        <AnnouncementBanner lang={lang} />
        <Navbar lang={lang} updateLangFunc={this.update_lang} />
        <Breadcrumb lang={lang} items={[{ label: { zh: "部落格", en: "Blog", ja: "ブログ" } }]} />

        <div className="blog_hero">
          <div className="blog_hero_inner">
            <h1>{this.state.heroTitle[lang]}</h1>
          </div>
        </div>

        <div className="blog_content_area">
          <div className="blog_category_bar">
            {categories.map(cat => (
              <button
                key={cat}
                className={"blog_cat_btn" + (this.state.activeCategory === cat ? " blog_cat_active" : "")}
                aria-pressed={this.state.activeCategory === cat}
                onClick={() => this.setState({ activeCategory: cat })}
              >
                {this.state.categoryLabels[cat] ? this.state.categoryLabels[cat][lang] : cat}
              </button>
            ))}
          </div>

          <div className="blog_posts_grid">
            {filtered.map((post, idx) => {
              const hasLink = !!post.link;
              const isExpanded = !hasLink && this.state.expandedId === post.id;
              return (
              <Fade duration={300} delay={idx * 40} key={post.id}>
                <div
                  id={post.id}
                  className={"blog_post_card" + (hasLink ? " blog_post_card_link" : "") + (isExpanded ? " blog_post_expanded" : "")}
                  onClick={hasLink ? () => this.navigate(post.link) : undefined}
                >
                  <div className="blog_post_img" role="img" aria-label={post.title[lang]} style={{backgroundImage: 'url(' + post.image + ')', backgroundPosition: post.image_position || 'center'}} />
                  <div className="blog_post_body">
                    <div className="blog_post_meta">
                      <span className="blog_post_category">{post.category[lang]}</span>
                      <span className="blog_post_date">{post.date}</span>
                    </div>
                    <h3 className="blog_post_title">{post.title[lang]}</h3>
                    <p className="blog_post_excerpt">
                      {isExpanded ? post.content[lang] : post.excerpt[lang]}
                    </p>
                    <button
                      className="blog_post_readmore"
                      aria-expanded={hasLink ? undefined : isExpanded}
                      onClick={(e) => {
                        if (hasLink) {
                          e.stopPropagation();
                          this.navigate(post.link);
                        } else {
                          this.setState({
                            expandedId: this.state.expandedId === post.id ? null : post.id
                          });
                        }
                      }}
                    >
                      {hasLink
                        ? readArticleLabel[lang] + " →"
                        : (this.state.expandedId === post.id ? collapseLabel[lang] : readMoreLabel[lang])}
                    </button>
                  </div>
                </div>
              </Fade>
              );
            })}
          </div>
        </div>

        <Footer lang={lang} navigate={this.navigate} />
      </div>
    );
  }
}

export default BlogPage;
